import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loadAllAuth, loginWithGoogle } from '../auth/AuthSlice';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme, useMediaQuery } from '@mui/material';
import DesktopHomeContent from './DesktopHomeContent';
import MobileHomeContent from './MobileHomeContent';

function Home() {
    const user = useSelector((state) => state.auth.user);
    const isLoading = useSelector((state) => state.auth.isLoading);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const connectionsLoaded = useSelector((state) => state.auth.connectionsLoaded);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleLogin = () => dispatch(loginWithGoogle());

    // Load all auth data when user is authenticated and connections not yet loaded
    useEffect(() => {
        if (user && !connectionsLoaded && !isLoading) {
            dispatch(loadAllAuth());
        }
    }, [user, connectionsLoaded, isLoading, dispatch]);

    // If user is logged in and we have a saved location, redirect there
    useEffect(() => {
        if (user && location.state?.from) {
            navigate(location.state.from, { replace: true });
        }
    }, [user, location.state?.from, navigate]);

    // Redirect authenticated users to /routes
    useEffect(() => {
        if (user && !isLoading && connectionsLoaded && !!!location.state?.from) {
            navigate('/routes', { replace: true });
        }
    }, [user, isLoading, connectionsLoaded, navigate, location.state?.from]);

    // Show nothing while loading
    if (isLoading) {
        return (
            <Box className="print-overflow-auto" sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
            }}>
                <CircularProgress />
            </Box>
        );
    }

    // Desktop marketing site for non-authenticated users
    if (!user && !isMobile) {
        return <DesktopHomeContent onLogin={handleLogin} />;
    }

    // Mobile app interface for authenticated users or mobile users
    if (!user && isMobile) {
        return <MobileHomeContent onLogin={handleLogin} />;
    }

    // This should not be reached for authenticated users due to redirect above
    return null;
}


export default Home;